import script from "./RegistrationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=0cad8ce7&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cad8ce7"]])

export default __exports__